<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span v-if="id > 0" class="pr-2 mr-2 font-bold text-2xl"
        >Faktur Penjualan - Edit</span
      >
      <span v-else class="pr-2 mr-2 font-bold text-2xl"
        >Faktur Penjualan - Tambah</span
      >
      <div>
        <i class="pi pi-home mr-2"></i>
        <span v-if="id > 0" class="font-small"
          >/ Penjualan / Faktur Penjualan / Edit</span
        >
        <span v-else class="font-small"
          >/ Penjualan / Faktur Penjualan / Tambah</span
        >
      </div>
    </div>
    <form-sales-invoice :id="id" />
  </div>
</template>

<script>
import FormSalesInvoice from '@/components/penjualan/FormSalesInvoice'

export default {
  components: {
    FormSalesInvoice,
  },
  data() {
    return {
      id: parseInt(this.$route.params.id),
    }
  },
}
</script>
